import type { AssetTypeDetailsTabProps } from "./asset-type-details-tab.type";

import { Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router";

import AssetTypeCategory from "@/modules/asset-type/asset-type-category";
import AssetTypeTemplateLink, {
  getAssetTypeTemplateLink,
} from "@/modules/asset-type/asset-type-template-link";
import { FlexContainerText } from "@/modules/flex-container";
import { HelpCenterArticleLink } from "@/modules/help-center";
import { InformationSection } from "@/ui/information-section";

import "./asset-type-details-tab.style.less";

const { Paragraph } = Typography;

const FALLBACK_VALUE = "—";

const AssetTypeDetailsTab = ({ assetType }: AssetTypeDetailsTabProps) => {
  const { t } = useTranslation();

  const sectionLink = "/technical-forms";
  const templateLink = getAssetTypeTemplateLink(assetType) ?? sectionLink;

  return (
    <div className="asset-type-details-tab">
      <InformationSection type="info" title={t("assetType:infoSection")}>
        <FlexContainerText
          label={t("assetType:form.name.label")}
          value={assetType.name}
        />
        <FlexContainerText
          label={t("assetType:form.category.label")}
          value={
            <AssetTypeCategory
              assetType={assetType}
              fallback={FALLBACK_VALUE}
            />
          }
        />
        <FlexContainerText
          label={t("assetType:technicalForm.title")}
          value={
            <AssetTypeTemplateLink
              assetType={assetType}
              fallback={FALLBACK_VALUE}
              linkProps={{ target: "_blank" }}
            />
          }
        />
        <FlexContainerText
          label={t("assetType:linkedAssets")}
          value={`${assetType.assets_count ?? 0}`}
        />
      </InformationSection>
      <InformationSection type="warning">
        <Paragraph strong>
          <Trans
            i18nKey="assetType:technicalForm.warning"
            components={{
              TemplateLink: <Link to={templateLink} target="_blank" />,
            }}
          />
        </Paragraph>
        <Paragraph>
          <HelpCenterArticleLink
            type="technicalForm"
            showInfoIcon
            showBlankIcon
          />
        </Paragraph>
      </InformationSection>
    </div>
  );
};

export default AssetTypeDetailsTab;
